import React from "react";
import Label from "./Label";
import Divider from "./Divider";
import Float from "./Float";
import Button from "./Button";
import Menu from "./Menu";
import { KBD } from "../utils/Keybindings";
import ModalButton from "./ModalButton";

export default function Popup(props) {

    const { closable = true, callback = () => { }, width = 200, title = "Popup", component, hide_header = false, className = "ui-popup" } = props;

    let _style = {
        width: (width === "auto") ? "auto" : width + "px"
    }


    return (
        <div style={_style} className={className}>
            {(!hide_header &&
                <>
                    <div style={{ "padding": "7px 10px" }}>
                        <Float>
                            <Label style={{ "textAlign": "left" }}>{title}</Label>
                            {(closable && <ModalButton onClick={() => callback()} style={{ "marginTop": "-2px" }} value={<>&times;</>} />)}
                        </Float>
                    </div>
                    <Divider style={{ "margin": "0px 0px", "width": "100%" }} />
                </>
            )}

            <div>
                {component}
            </div>
        </div>
    )
}